var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgHomeWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-41820cbd-8f00-44f4-9081-3f7c9af1c26a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M80.92,91.77c-22.51,.05-45.02,.1-67.53,.15-.79-.05-2.01-.24-2.79-1.11-.75-.84-.74-1.93-.74-2.33,.01-2.44-.02-21.34,0-47.33",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.34,39.87C18.85,28.4,33.35,16.93,47.86,5.45c.51-.31,1.22-.62,2.05-.58,0,0,.77,.04,1.53,.47,1.93,1.11,40.66,31.39,44.26,34.21",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.92,40.24v43.3",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.06,90.35c.02-11.27,.05-22.55,.07-33.82,.01-.18,.11-1.33,1.12-2.11,.91-.69,1.9-.59,2.11-.56,6.01-.05,12.02-.09,18.04-.14,.29,.06,1.26,.29,1.96,1.19,.42,.54,.57,1.09,.63,1.4,.05,11.39,.09,22.78,.14,34.18",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgHomeWhite);
export default __webpack_public_path__ + "static/media/SvgHomeWhite.4f1dafa8f1caa77856cb0bebe69f21ac.svg";
export { ForwardRef as ReactComponent };